import { KeyValue } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Act } from 'src/logic/act';
import { Actions } from 'src/logic/enum/actions';
import { AppViewStates } from 'src/logic/enum/app-view-states';
import * as ace from "ace-builds";
import { Model } from 'src/logic/model';
import { Utilits } from 'src/logic/utilits';
import { DropDownItem } from 'src/logic/types/drop-down-item';


@Component({
    selector: 'app-replacing',
    templateUrl: './replacing.component.html',
    styleUrls: ['./replacing.component.less'],
    standalone: false
})
export class ReplacingComponent implements OnInit {

  [key: string]: any;
  constructor(public act: Act, public model: Model) { }

  @ViewChild("editor")
  private editor!: ElementRef<HTMLElement>;

  Utilits = Utilits;
  Actions = Actions;

  /**искомый текст */
  textFind: string = '';
  /**текст который заменяем/вставляем */
  textNew: string = '';
  /**кроме фраз */
  textExcept: string = '';
  /**исходный текст */
  textSource: string = '';
  /**результат */
  textResult: string = '';
  /**результат выполнения js скрипта */
  textScriptResult: string = '';
  /**Regex1 */
  textRegex1: string = '';
  /**Regex2 */
  textRegex2: string = '';

  chkReplace: boolean = true;

  /**учитывать регистр */
  chkCase: boolean = false;

  blockTextReplacingVis: boolean = true;
  blockScriptVis: boolean = true;

  readonly fieldsNamesSaveList = ['textFind','textNew','textExcept','textSource','textResult','textScriptResult','textRegex1','textRegex2','selectedResultType','selectedActionKey'];

  /**действия - выпадающий список */
  actionsList: DropDownItem[] = [
      {key:'replace',value:'Действие Замена'}
    , {key:'replacePreserveFirstLetterCase',value:'Замена оставляя регистр первой буквы'}
    
    , {key:'filterContains',value:'Фильтр списка: по вхождению', description:'разделяет список по запятым или новым строкам (что есть) и фильтрует'}
    , {key:'filterStartsWith',value:'Фильтр списка: начинается с', description:'разделяет список по запятым или новым строкам (что есть) и фильтрует'}
    , {key:'inQuotesSingle',value:'Список в кавычки \'',description:'разделяет список по запятым или новым строкам (что есть) и каждое слово ставит в одинарные кавычки'}
    , {key:'inQuotesDouble',value:'Список в кавычки "',description:'разделяет список по запятым или новым строкам (что есть) и каждое слово ставит в двойные кавычки'}
    , {key:'splitCommaToLines',value:'Список Через запятую -> строки'}
    , {key:'splitLinesToComma',value:'Список Строки -> через запятую'}

    , {key:'invertSlashRemoveQuotes',value:'Инвертировать слэши / \ и убрать кавычки'}
    , {key:'fileNameFromPath',value:'Имя файла из пути'} 
    , {key:'wordsToSingleWordPascalCase',value:'Слова в одно PascalCase'}
    , {key:'wordsFirstLetterToUpperCase',value:'Слова первую букву в верхний регистр'}
    , {key:'wordsFirstLetterToLowerCase',value:'Слова первую букву в нижний регистр'}
    , {key:'insertBeforeWords',value:'Вставить Перед каждым словом (не символом)'}


    // , {key:'insertAfter',value:'Вставить После'}
    // , {key:'betweenRegex1AndRegex2',value:'Выборка текста между regex1 и regex2'}
    // , {key:'wordsToFormatWithoutTransform',value:'Слова без преобразования в выбранный вид'}
    // , {key:'filterLinesByRegex',value:'Фильтр строк по regex1'}
    // , {key:'linesToFormatWithoutTransform',value:'Каждую строку перенос без преобразования в выбранный вид'}

  ]; //, {key:'',value:''}
  
  /**выбранное действие */
  selectedAction: DropDownItem | null = null;

  /**типы результата - выпадающий список */
  resultTypes: KeyValue<string, string>[] = [{key:'textCommaSeparated',value:'Результат Текст через запятую'}
    , {key:'stringArray',value:'Результат Массив строк'}/*, {key:'Результат Строки',value:'lines'}*/ ]; //, {key:'',value:''}

  /**выбранный вид результата */
  selectedResultType: string = '';

  ngOnInit(): void {
    this.actionSelected(this.actionsList[0]);
    this.selectedResultType = this.resultTypes[1].key;

    // ace.config.set("fontSize", "14px");
    // setTimeout(()=>{
    //   this.model.replacingScriptAceEditor = ace.edit(this.editor.nativeElement);
      
    //   this.model.replacingScriptAceEditor.setTheme("ace/theme/chrome");
    //   this.model.replacingScriptAceEditor.getSession().setMode("ace/mode/javascript");
    //   this.model.replacingScriptAceEditor.getSession().setUseWorker(false);
    //   this.model.replacingScriptAceEditor.renderer.setShowGutter(false);

    // },0);

    let valsStr = localStorage.getItem('replacingCompVals');
    if(valsStr){
      let obj = JSON.parse(valsStr);
      this.fieldsNamesSaveList.forEach((n: string)=>{
        this[n] = obj[n];
      });
    }
  }

  copy(val: string){
    navigator.clipboard.writeText(val);
  }

  splitTextToList(text:string): Array<string> {
    if(text.indexOf(',')>-1){
      return text.split(',').map(x=>x.trim());
    }else{
      return text.split('\n').map(x=>x.trim());
    }
  }

  getListFromSourceText(): Array<string>{
    return this.splitTextToList(this.textSource);
  }

  finishResultList(list: Array<string>){
    this.textResult = list.join(', ');
  }

  //операции с текстом
  run() {
    let textSource = this.textSource;
    let flags = this.chkCase ? 'g' : 'gi';
    let selectedActionKey = this.selectedAction?.key ?? '';
    if(selectedActionKey==''){
      return;
    }

        console.log('selectedActionKey',selectedActionKey,'flags',flags);

    if(['betweenRegex1AndRegex2'].includes(selectedActionKey) && ['stringArray'].includes(this.selectedResultType)){
      this.textResult = '[';
    } else {
      this.textResult = '';
    }

    let exceptWords = null;
    // if(this.textExcept.length > 0){
    //   exceptWords = this.textExcept.replace(/ /g,'').split(',').filter((v)=>v != '');
    //   for(let i=0;i<exceptWords.length;i++){
    //     textSource = textSource.replace(new RegExp(exceptWords[i], 'g'), `##except${i}##`);
    //   }    
    // }

    let foundCount = 0;

    //разные действия
    switch(selectedActionKey){

      case 'splitLinesToComma': {
        let list = textSource.split('\n').map(x=>x.trim());
        this.textResult = list.join(', ');
      } break;

      case 'splitCommaToLines': {
        let list = textSource.split(',').map(x=>x.trim());
        this.textResult = list.join('\n');
      } break;

      case 'inQuotesSingle': {
        let list = this.getListFromSourceText();
        let filteredList = list.map(x=>`'${x}'`);
        this.finishResultList(filteredList);
      } break;

      case 'inQuotesDouble': {
        let list = this.getListFromSourceText();
        let filteredList = list.map(x=>`"${x}"`);
        this.finishResultList(filteredList);
      } break;

      case 'filterStartsWith': {
        let list = this.getListFromSourceText();
        let filteredList = list.filter(x=>x.startsWith(this.textFind));
        this.finishResultList(filteredList);
      } break;

      case 'filterContains': {
        let list = this.getListFromSourceText();
        let filteredList = list.filter(x=>x.indexOf(this.textFind)>-1);
        this.finishResultList(filteredList);
      } break;

      case 'replace':
        //замена
        this.textResult = textSource.replace(new RegExp(`${this.textFind}`, flags), this.textNew)
                                    .replace(/\\n/g,'\n');
        console.log('flags',flags);
      break;
      
      case 'insertBeforeWords':
        {//Вставить Перед каждым словом (не символом)
        let i=0, prevLastIndex = 0;
        let regex = new RegExp(/[\d\wа-яА-ЯёЁ_]+/g);
          do{
            let resRegex = regex.exec(textSource);
            if(resRegex==null){
              this.textResult += textSource.substring(prevLastIndex);
              break;
            }
            this.textResult += textSource.substring(prevLastIndex, resRegex.index) + this.textNew + resRegex[0];
            prevLastIndex = regex.lastIndex;
          }while(i++<1000);
        }
      break;

      case 'betweenRegex1AndRegex2':
        { //Выборка текста между regex1 и regex2 и формирование списка
        let regex1 = new RegExp(this.textRegex1, flags);
        let regex2 = new RegExp(this.textRegex2, flags);
        try{
          do {
            let resRegex1 = regex1.exec(textSource);

            if(resRegex1==null){
              if(this.textResult.length == 0){
                this.message(`не найдено вхождения regex1`);
              }
              break;
            }
            //конец найденного выражения
            let resRegex1Length = resRegex1[0].length;
            let endIndefOfMatchRegex1 = resRegex1.index + resRegex1Length;
            //оттуда ищем дальше вхождение второго регекса
            regex2.lastIndex = endIndefOfMatchRegex1;
            let resRegex2 = regex2.exec(textSource);
            if(resRegex2==null){
              if(this.textResult.length == 0){
                this.message(`не найдено вхождения regex2 от позиции ${endIndefOfMatchRegex1}`);
              }
              break;
            }
            regex2.lastIndex =  resRegex2.index +  resRegex2[0].length;
            if(foundCount > 0){
              this.textResult += ', ';
            }
            let str = textSource.substring(endIndefOfMatchRegex1, resRegex2.index);
            switch(this.selectedResultType){
              case 'textCommaSeparated':
                this.textResult += str;
                break;
              case 'stringArray':
                this.textResult += `"${str}"`;
                break; 
            }
            foundCount++;
          }while(true);
        }catch(err){
          alert(err);
        }
      }
      break;

      case 'wordsToSingleWordPascalCase':
        { //Слова через раздел. в одно PascalCase
        let words = this.textSource.split(/[^\d\wа-яА-ЯёЁ_]+/g);
        for(let i=0; i < words.length ; i++)
        {
          words[i] = words[i].toLowerCase();
        }
        for(let i=1; i < words.length ; i++)
        {
          if(words[i].length > 0){
            const ch = words[i].charAt(0);
            words[i] = ch.toUpperCase() + ((words[i].length > 1) ? words[i].substring(1) : '');
          }
        }
        this.textResult = words.join('');
        }
      break;

      case 'wordsToFormatWithoutTransform':
        { //Слова через раздел. без преобр. в выбр. вид
        let words = this.textSource.split(/[^\d\wа-яА-ЯёЁ_]+/g);
        switch(this.selectedResultType){
          case 'textCommaSeparated':
            this.textResult = `${words.join(', ')}`;
            break;
          case 'stringArray':
            for(let i=0; i < words.length; i++)
            {
              this.textResult += (i>0 ? ', ':'') + `"${words[i]}"`;
            }
            break;                
        }}
      break;

      case 'filterLinesByRegex':
        { //Фильтр строк по regex1
        let lines = this.textSource.split(/\r?\n/g);
        lines = lines.filter(l => l.match(new RegExp(this.textRegex1, 'gi')));
        this.textResult = lines.join('\n');
        }
      break;

      case 'linesToFormatWithoutTransform':
        { //Построчный перенос без преобр. в выбр. вид
        let lines = this.textSource.split(/\r?\n/g);
        switch(this.selectedResultType){
          case 'textCommaSeparated':
            this.textResult = `${lines.join(', ')}`;
            break;
          case 'stringArray':
            for(let i=0; i < lines.length; i++)
            {
              this.textResult += (i>0 ? ', ':'') + `"${lines[i]}"`;
            }
            break;                
        }}
      break;
      
      case 'invertSlashRemoveQuotes':
        { //Инвертировать слэши / \ и убрать кавычки
          if(this.textSource.indexOf('/')>-1)
            this.textResult = this.textSource.replace(/\//g,'\\');
          else
            this.textResult = this.textSource.replace(/\\/g,'/');
          this.textResult = this.textResult.replace(/"/g,'').replace(/'/g,'');
        }
      break;
      
      case 'fileNameFromPath':
        { //Имя файла из пути
            let fileName = "";
            let ind = this.textSource.lastIndexOf('/');
            if(ind === -1)
              ind = this.textSource.lastIndexOf('\\');
            if(ind > -1){
              fileName = this.textSource.substring(ind+1);
            }
            this.textResult = fileName;
        }
      break;
      
      case 'replacePreserveFirstLetterCase':
        { //Замена оставляя регистр первой буквы
            if(this.textFind.length>0 && this.textNew.length>0){
              let firstLowerFind = (this.textFind.charAt(0)).toLowerCase() + this.textFind.substring(1);
              let firstUpperFind = (this.textFind.charAt(0)).toUpperCase() + this.textFind.substring(1);
              let firstLowerNew = (this.textNew.charAt(0)).toLowerCase() + this.textNew.substring(1);
              let firstUpperNew = (this.textNew.charAt(0)).toUpperCase() + this.textNew.substring(1);
              this.textResult = this.textSource.replace(new RegExp(firstLowerFind, 'g'), firstLowerNew);
              this.textResult = this.textResult.replace(new RegExp(firstUpperFind, 'g'), firstUpperNew);
            }
        }
      break;


    }

    // if(exceptWords != null){
    //   for(let i=0;i<exceptWords.length;i++){
    //     this.textResult = this.textResult.replace(new RegExp(`##except${i}##`, 'g'), exceptWords[i]);
    //   }
    // }

    if(['betweenRegex1AndRegex2'].includes(selectedActionKey) && ['stringArray'].includes(this.selectedResultType)){
      this.textResult += ']';
    }
  }

  runScript(){

    //js скрипт
    if(this.model.replacingScriptAceEditor){
    this.textScriptResult = '';
    let resTxt: string;
    if(/\[.*\]/g.test(this.textResult)
        || /\d+/.test(this.textResult)
        || /\'.*\'/.test(this.textResult)
        || /\".*\"/.test(this.textResult)){
      //в поле Результат Замены массив или число или строка в кавычках
      resTxt = `[${this.textResult}]`;
    } else {
      resTxt = `'${this.textResult}'`;
    }
    resTxt = resTxt.replace(/\"/g, "'");
    let textSource = this.textSource.replace(/\"/g, "'");
    this.model.replacingScriptText = this.model.replacingScriptAceEditor.getValue();
    let textScript = 
    `function w(s){ res+=s; }\n function wq(s){ res+='"'+ s +'"'; }\n function q(s){ return '"'+ s +'"'; }\n function wl(s){ res+=s+'\\n'; }\n  function wl2(s){ res+='\\n'+s+'\\n'; }\n `
    +`var src="${textSource}"; var res=''; var textres=${resTxt}; \n` + this.model.replacingScriptText + '\nres;';
    console.log('textScript',textScript);
    try{
      this.textScriptResult = eval(textScript);
    }catch(err: any){
      console.log('err',err);
      this.textScriptResult = `Ошибка скрипта: ${err.toString()}`;
    }
    }
  }

  onRunKey(ev: KeyboardEvent, withControl: boolean = false){
    if(ev.code==='Enter' && (!withControl || ev.ctrlKey))
      this.run();
  }

  onRunScriptKey(ev: KeyboardEvent){
    if(ev.ctrlKey && ev.code==='Enter')
      this.runScript();
  }

  swapText(){
    let t = this.textSource;
    this.textSource = this.textResult;
    this.textResult = t;    
    this.saveState();
  }

  openSnippets(){
    this.act.do(Actions.changeAppViewState, AppViewStates.snippets);
    window.scrollTo(0,0);
  }

  onBlur(){
    this.saveState();
  }

  saveState(){
    let obj:any = {};
    this.fieldsNamesSaveList.forEach((n: string)=>{
      obj[n] = this[n];
    });
    localStorage.setItem('replacingCompVals',JSON.stringify(obj));    
  }

  clearTextSourceClick(){
    this.textSource='';
    setTimeout(()=>{
      document.getElementById('textSourceEl')?.focus();
    },0);
    this.saveState();
  }

  clearClick(){
    this.textFind = '';
    this.textNew = '';
    this.textExcept = '';
    this.textSource='';
    this.textRegex1='';
    this.textRegex2='';
    this.saveState();

    setTimeout(()=>{
      document.getElementById('textSourceEl')?.focus();
    },0);
  }

  scriptClearAndFocus(){
    if(this.model.replacingScriptAceEditor){
    this.model.replacingScriptAceEditor.setValue('');
    this.model.replacingScriptAceEditor.focus();
    }
  }

  actionSelected(it: DropDownItem){
    this.selectedAction = it;
  }

  message(text: string){
    alert(text);
  }
}
